import gql from 'graphql-tag';

export const ALLUSUARIOS = gql`
 query todosUs{
    usuarios{
      id
      username
      nombres
      apellidos
      activo
      rol{
        id
        nombre
      }
    }
  }
`;

export const USUARIO = gql`
  query us($id:Int!){
    usuario(id:$id){
      id
      username
      nombres
      regional
      apellidos
      activo
      rol{
        id
        nombre
        permisos{
          id
          nombre
        }
      }
      tiendas{
        id
        nombre
      }
    }
  }
`;

export const USUARIOTIENDA = gql`
  query us($id:Int!){
    usuario(id:$id){
      tiendas{
        id
        nombre
      }
    }
  }
`;

export const EDITUSUARIO = gql`
  mutation actUser($id:Int!, $username:String!, $nombres:String!, $apellidos: String!, $contrasena:String!, $rol:Int!,  $regional:String, $tiendas:[Int], $activo:Boolean){
    updateUser(id:$id, user:{
      username:$username
      nombres:$nombres
      apellidos:$apellidos
      contrasena:$contrasena
      rol:$rol
      regional:$regional
      tiendas:$tiendas
      activo:$activo
    }){
      id
    }
  }
`;

export const NEWUSUARIO = gql`
  mutation crearUser($username:String!, $nombres:String!, $apellidos: String!, $contrasena:String!, $rol:Int!, $tiendas:[Int], $regional:String, $activo:Boolean){
    addUser(user:{
      username:$username
      nombres:$nombres
      apellidos:$apellidos
      contrasena:$contrasena
      rol:$rol
      regional:$regional
      tiendas:$tiendas
      activo:$activo
    }){
      id
    }
  }
`;


export const GETPERMISOSUSUARIO = gql`
  query ($idUser:Int!){
    permisosxUsuario(idUser:$idUser){
      id
      nombre
    }
  }
`;
